import type { RouteRecordRaw } from 'vue-router'
import { Routes } from '../../Constants/Routes.ts'
import TotpSetupPage from '../../Views/User/TotpSetupPage.vue'
import { assertThat } from '../Guards'

const routes: RouteRecordRaw[] = [
  {
    name: Routes.USER_TOTP_SETUP,
    path: '/user/totp/setup',
    component: TotpSetupPage,
    meta: {
      guards: assertThat().authenticated(),
    },
  },
]

export default routes
